/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Billing_Contract_Overage_ShortInputs */



/**
* | output |
* | --- |
* | "Overage {amount} to charge" |
*
* @param {Partner_Billing_Contract_Overage_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_contract_overage_short = /** @type {((inputs: Partner_Billing_Contract_Overage_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Contract_Overage_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Überschuss ${i?.amount} abzurechnen`)
	return /** @type {LocalizedString} */ (`Overage ${i?.amount} to charge`)
});